import { setMatchData } from '../models/Marketplace/Market/store';
import { getAllCoverages, setCoverage, generateId } from '../store';
import ApiRoutes from '../store/ApiRoutes';
import cogoToast from 'cogo-toast';
import {
  resetSkippedSteps,
  removeFromCheckout,
} from '../models/Marketplace/LayoutMarket/store';
import { setCarValue, addDataForIdCar } from '../models/Flow/Car/store';
import { getNestedObject } from './objectService';

const api = new ApiRoutes();

export const setTabItems = (
  id,
  t,
  pageType,
  currentPage,
  revision,
  state,
  prospectId,
) => {
  // console.log('setTabs pageType: ', pageType);
  let navTabs = [];

  switch (pageType) {
    case 'offersOverview':
      navTabs.push({
        title: t('Offers'),
        to: `/sales-management/contracts/offers/${currentPage}`,
        testId: `customer_detail_nav`,
        state,
      });

      navTabs.push({
        title: t('Leads'),
        to: `/sales-management/contracts/leads/1`,
        testId: `customer_detail_contract_nav`,
        state,
      });
      break;
    case 'offerDetail':
      navTabs.push({
        title: t('Offer'),
        to: `/sales-management/offer/${id}/${revision}`,
        testId: `customer_detail_offer`,
        state,
      });
      navTabs.push({
        title: t('Revisions'),
        to: `/sales-management/offer/${id}/${revision}/revisions`,
        testId: `customer_detail_offer_revisions`,
        state,
      });
      break;
    case 'offerDetailCustomer':
      navTabs.push({
        title: t('Offer'),
        to: `/sales-management/customer/${prospectId}/contracts/offer/${id}/${revision}`,
        testId: `customer_detail_offer`,
        state,
      });
      navTabs.push({
        title: t('Revisions'),
        to: `/sales-management/customer/${prospectId}/contracts/offer/${id}/${revision}/revisions`,
        testId: `customer_detail_offer_revisions`,
        state,
      });
      break;
    case 'leadsOverview':
      navTabs.push({
        title: t('Offers'),
        to: `/sales-management/contracts/offers/1`,
        testId: `customer_detail_nav`,
        state,
      });

      navTabs.push({
        title: t('Leads'),
        to: `/sales-management/contracts/leads/${currentPage}`,
        testId: `customer_detail_contract_nav`,
        state,
      });
      break;
    case 'prospectDetail':
      navTabs.push({
        title: t('Prospect.Client information'),
        to: `/sales-management/customer/${id}`,
        testId: `customer_detail_prospect_nav`,
        state,
      });

      navTabs.push({
        title: t('Offers and leads'),
        to: `/sales-management/customer/${id}/contracts`,
        testId: `customer_detail_prospect_contracts_nav`,
        state,
      });
      break;
    case 'prospectDetailWithContracts':
      navTabs.push({
        title: t('Prospect.Client information'),
        to: `/sales-management/customer/${id}`,
        testId: `customer_detail_prospect_nav`,
        state,
      });

      navTabs.push({
        title: t('Offers and contracts'),
        to: `/sales-management/customer/${id}/contracts`,
        testId: `customer_detail_prospect_contracts_nav`,
        state,
      });
      break;
    case 'contractDetail':
      navTabs.push({
        title: t('Contract'),
        to: `/sales-management/case/${id}/contract/${revision}`,
        testId: `customer_detail_offer`,
        state,
      });

      navTabs.push({
        title: t('Addendums'),
        to: `/sales-management/case/${id}/contract/${revision}/addendums`,
        testId: `customer_detail_contract_addendums`,
        state,
      });
      break;
    case 'contractDetailCustomer':
      navTabs.push({
        title: t('Contract'),
        to: `/sales-management/customer/${prospectId}/contracts/case/${id}/contract/${revision}`,
        testId: `customer_detail_offer`,
        state,
      });

      navTabs.push({
        title: t('Addendums'),
        to: `/sales-management/customer/${prospectId}/contracts/case/${id}/contract/${revision}/addendums`,
        testId: `customer_detail_contract_addendums`,
        state,
      });
      break;

    default:
      break;
  }
  return navTabs;
};

export const gotoMatches = (types, history) => {
  resetSkippedSteps();

  if (types.includes('home')) {
    history.push('/review/market/fire');
  } else if (types.includes('family')) {
    history.push('/review/market/family');
  } else if (types.includes('car')) {
    history.push('/review/market/car');
  } else {
    history.push('/review/market/legal');
  }
};

export const getHistory = (
  id,
  filteredInsureTypes,
  history,
  t,
  sessionData,
) => {
  console.log(t('Loading your data'));
  const closeLoading = cogoToast.loading(t('Loading your data'), {
    hideAfter: 0,
  });
  removeFromCheckout('fire');
  removeFromCheckout('people');
  removeFromCheckout('car');
  removeFromCheckout('legal');
  sessionStorage.setItem('sessionId', id);
  generateId().then(resp => {
    api.getSession(id).then(() => {
      Promise.all(
        filteredInsureTypes.map(insurType => {
          if (insurType === 'car') {
            addDataForIdCar(resp.id);
            setCarValue(
              'primary_driver',
              getNestedObject(sessionData, ['car', 'primary_driver']),
            );
          }
          return api.getMatchingScores(insurType, id);
        }),
      )
        .then(res => {
          res.forEach((obj, i) => {
            setMatchData(
              filteredInsureTypes[i] === `home`
                ? `fire`
                : filteredInsureTypes[i],
              obj.data,
            );
          });
          closeLoading();
          cogoToast.success(t('Data Successfully Loaded'));
          gotoMatches(filteredInsureTypes, history);
        })
        .catch(err => {
          closeLoading();
          console.error(err);
          cogoToast.error(t('Something went wrong while retrieving your data'));
        });
    });
  });
};

const filterSessionData = sessionData => {
  const insurTypes = ['home', 'family', 'car', 'legal'];
  Object.keys(getAllCoverages()).forEach(coverage => {
    if (sessionData[coverage]) {
      setCoverage(coverage, true);
    } else {
      setCoverage(coverage, false);
    }
  });
  return insurTypes.filter(t => getAllCoverages()[t]);
};

export const setInsurTypes = id => {
  const sessionData = JSON.parse(sessionStorage.getItem(`sessionData_${id}`));
  if (sessionData)
    return new Promise(resolve => {
      resolve({ filteredData: filterSessionData(sessionData), sessionData });
    });

  return api.getSession(id).then(({ data }) => {
    sessionStorage.setItem(`sessionData_${id}`, JSON.stringify(data));
    return { filteredData: filterSessionData(data), sessionData: data };
  });
};

export const formatCRMAddress = addressObject => {
  let address = '';
  const boxnrRegex = new RegExp('[a-zA-Z]+');
  if (addressObject) {
    if (addressObject?.boxnr !== null) {
      if (boxnrRegex.test(addressObject?.boxnr)) {
        address = `${addressObject?.street} ${addressObject?.housenr}${addressObject?.boxnr}, ${addressObject?.zipcode} ${addressObject?.city}`;
      } else {
        address = `${addressObject?.street} ${addressObject?.housenr}/${addressObject?.boxnr}, ${addressObject?.zipcode} ${addressObject?.city}`;
      }
    } else {
      address = `${addressObject?.street} ${addressObject?.housenr}, ${addressObject?.zipcode} ${addressObject?.city}`;
    }
  } else {
    address = '-';
  }
  return address;
};
